// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"_confirmation-Subtitle-module--subtitle--1hHK4"};